// Prefer 127.0.0.1 to avoid IPv6/localhost redirects from PHP server
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://127.0.0.1:8000/api/v1';

type RequestOptions = RequestInit & {
  token?: string;
};

export async function apiClient<TResponse>(path: string, options: RequestOptions = {}): Promise<TResponse> {
  const { token, headers, ...rest } = options;

  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...rest,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(headers ?? {}),
    },
    redirect: 'manual',
  });

  if (res.type === 'opaqueredirect' || (res.status >= 300 && res.status < 400)) {
    const location = res.headers.get('Location') ?? 'unknown';
    throw new Error(`Unexpected redirect to ${location}. Request aborted.`);
  }

  if (res.status === 204) {
    return undefined as TResponse;
  }

  const contentType = res.headers.get('content-type') ?? '';
  let payload: unknown;

  if (contentType.includes('application/json')) {
    try {
      payload = await res.json();
    } catch (error) {
      throw new Error('Received malformed JSON response from server.');
    }
  } else {
    const text = await res.text();
    if (!res.ok) {
      throw new Error(text || 'Request failed.');
    }
    throw new Error('Unexpected non-JSON response received from server.');
  }

  if (!res.ok) {
    const message =
      (typeof payload === 'object' && payload !== null && 'message' in payload && typeof payload.message === 'string'
        ? payload.message
        : null) ?? 'Request failed.';
    throw new Error(message);
  }

  return payload as TResponse;
}

